//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { DateTime, Duration } from "luxon";

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44370";
    }

    token(userLogin: UserLoginDTO): Observable<UserTokenDTO> {
        let url_ = this.baseUrl + "/Token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userLogin);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTokenDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTokenDTO>;
        }));
    }

    protected processToken(response: HttpResponseBase): Observable<UserTokenDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTokenDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClientClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44370";
    }

    getClient(id: number | undefined): Observable<ClientDTO> {
        let url_ = this.baseUrl + "/api/Client/GetClient?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDTO>;
        }));
    }

    protected processGetClient(response: HttpResponseBase): Observable<ClientDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchClients(skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, filters: FilterDTO[] | undefined): Observable<PagedResultDTOOfClientDTO | null> {
        let url_ = this.baseUrl + "/api/Client/SearchClients?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfClientDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfClientDTO | null>;
        }));
    }

    protected processSearchClients(response: HttpResponseBase): Observable<PagedResultDTOOfClientDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDTOOfClientDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class IncidentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44370";
    }

    searchIncidents(skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, filters: FilterDTO[] | undefined): Observable<PagedResultDTOOfIncidentDTO | null> {
        let url_ = this.baseUrl + "/api/Incident/SearchIncidents?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchIncidents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchIncidents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfIncidentDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfIncidentDTO | null>;
        }));
    }

    protected processSearchIncidents(response: HttpResponseBase): Observable<PagedResultDTOOfIncidentDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDTOOfIncidentDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createIncident(dto: CreateIncidentDTO): Observable<IncidentDTO | null> {
        let url_ = this.baseUrl + "/api/Incident/CreateIncident";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateIncident(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateIncident(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncidentDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncidentDTO | null>;
        }));
    }

    protected processCreateIncident(response: HttpResponseBase): Observable<IncidentDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? IncidentDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteIncident(id: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Incident/DeleteIncident?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteIncident(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteIncident(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeleteIncident(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InfoPopupClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44370";
    }

    searchInfoPopups(skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, filters: FilterDTO[] | undefined): Observable<PagedResultDTOOfInfoPopupDTO | null> {
        let url_ = this.baseUrl + "/api/InfoPopup/SearchInfoPopups?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchInfoPopups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchInfoPopups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfInfoPopupDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfInfoPopupDTO | null>;
        }));
    }

    protected processSearchInfoPopups(response: HttpResponseBase): Observable<PagedResultDTOOfInfoPopupDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDTOOfInfoPopupDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMobileInfoPopup(platform: InfoPopupPlatform | undefined, appVersion: string | undefined): Observable<InfoPopupDTO | null> {
        let url_ = this.baseUrl + "/api/InfoPopup/GetMobileInfoPopup?";
        if (platform === null)
            throw new globalThis.Error("The parameter 'platform' cannot be null.");
        else if (platform !== undefined)
            url_ += "platform=" + encodeURIComponent("" + platform) + "&";
        if (appVersion === null)
            throw new globalThis.Error("The parameter 'appVersion' cannot be null.");
        else if (appVersion !== undefined)
            url_ += "appVersion=" + encodeURIComponent("" + appVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMobileInfoPopup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMobileInfoPopup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfoPopupDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfoPopupDTO | null>;
        }));
    }

    protected processGetMobileInfoPopup(response: HttpResponseBase): Observable<InfoPopupDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InfoPopupDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInfoPopup(id: number | undefined): Observable<InfoPopupDTO> {
        let url_ = this.baseUrl + "/api/InfoPopup/GetInfoPopup?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInfoPopup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInfoPopup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfoPopupDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfoPopupDTO>;
        }));
    }

    protected processGetInfoPopup(response: HttpResponseBase): Observable<InfoPopupDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InfoPopupDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createInfoPopup(dto: CreateInfoPopupDTO): Observable<InfoPopupDTO | null> {
        let url_ = this.baseUrl + "/api/InfoPopup/CreateInfoPopup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInfoPopup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInfoPopup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfoPopupDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfoPopupDTO | null>;
        }));
    }

    protected processCreateInfoPopup(response: HttpResponseBase): Observable<InfoPopupDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InfoPopupDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateInfoPopup(dto: UpdateInfoPopupDTO): Observable<InfoPopupDTO | null> {
        let url_ = this.baseUrl + "/api/InfoPopup/UpdateInfoPopup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInfoPopup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInfoPopup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfoPopupDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfoPopupDTO | null>;
        }));
    }

    protected processUpdateInfoPopup(response: HttpResponseBase): Observable<InfoPopupDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InfoPopupDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteInfoPopup(id: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/InfoPopup/DeleteInfoPopup?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteInfoPopup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInfoPopup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeleteInfoPopup(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PushNotificationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44370";
    }

    sendPushNotification(model: SendPushNotificationDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/PushNotification/SendPushNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPushNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPushNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendPushNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ServiceClientClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44370";
    }

    searchServiceClients(skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, filters: FilterDTO[] | undefined): Observable<PagedResultDTOOfServiceClientDTO | null> {
        let url_ = this.baseUrl + "/api/ServiceClient/SearchServiceClients?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchServiceClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchServiceClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfServiceClientDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfServiceClientDTO | null>;
        }));
    }

    protected processSearchServiceClients(response: HttpResponseBase): Observable<PagedResultDTOOfServiceClientDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDTOOfServiceClientDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAdminLanguagesByClientIds(clientIds: number[]): Observable<string[]> {
        let url_ = this.baseUrl + "/api/ServiceClient/GetAdminLanguagesByClientIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(clientIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminLanguagesByClientIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminLanguagesByClientIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAdminLanguagesByClientIds(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ServiceStatusClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44370";
    }

    getAll(): Observable<StatusServiceDTO[]> {
        let url_ = this.baseUrl + "/api/ServiceStatus/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusServiceDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusServiceDTO[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<StatusServiceDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StatusServiceDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createServiceStatus(dto: CreateStatusServiceDTO): Observable<StatusServiceDTO | null> {
        let url_ = this.baseUrl + "/api/ServiceStatus/CreateServiceStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateServiceStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateServiceStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusServiceDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusServiceDTO | null>;
        }));
    }

    protected processCreateServiceStatus(response: HttpResponseBase): Observable<StatusServiceDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusServiceDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateServiceStatus(dto: UpdateStatusServiceDTO): Observable<StatusServiceDTO | null> {
        let url_ = this.baseUrl + "/api/ServiceStatus/UpdateServiceStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateServiceStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateServiceStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusServiceDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusServiceDTO | null>;
        }));
    }

    protected processUpdateServiceStatus(response: HttpResponseBase): Observable<StatusServiceDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusServiceDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteServiceStatus(id: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ServiceStatus/DeleteServiceStatus?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteServiceStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteServiceStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeleteServiceStatus(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserAccountClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44370";
    }

    info(): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/Info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processInfo(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchUsers(clientId: number | null | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, filters: FilterDTO[] | undefined): Observable<PagedResultDTOOfUserInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/SearchUsers?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfUserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfUserInfoDTO>;
        }));
    }

    protected processSearchUsers(response: HttpResponseBase): Observable<PagedResultDTOOfUserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfUserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setUserLanguage(language: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/UserAccount/SetUserLanguage?";
        if (language === null)
            throw new globalThis.Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUserLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUserLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetUserLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUser(model: UpdateUserInfoDTO): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/UpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addMobileUser(model: CreateMobileUserDTO): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/AddMobileUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddMobileUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddMobileUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processAddMobileUser(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    regenerateAccessCode(userId: string | undefined): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/RegenerateAccessCode?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegenerateAccessCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegenerateAccessCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processRegenerateAccessCode(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addUser(model: CreateUserDTO): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/AddUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processAddUser(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    logout(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/UserAccount/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changePassword(model: ChangePasswordDTO): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/UserAccount/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setPassword(model: SetPasswordDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/UserAccount/SetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    forgotPassword(model: ForgotPasswordDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/UserAccount/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processForgotPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMinimumClientVersion(): Observable<MinimumClientVersionDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/GetMinimumClientVersion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMinimumClientVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMinimumClientVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MinimumClientVersionDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MinimumClientVersionDTO>;
        }));
    }

    protected processGetMinimumClientVersion(response: HttpResponseBase): Observable<MinimumClientVersionDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MinimumClientVersionDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class UserTokenDTO implements IUserTokenDTO {
    access_token?: string | undefined;
    token_type?: string | undefined;
    username?: string | undefined;
    clientId?: string | undefined;
    refresh_token?: string | undefined;
    refreshTokenExpiresIn?: number;
    expires_in?: number;
    expires?: string | undefined;

    constructor(data?: IUserTokenDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.access_token = _data["access_token"];
            this.token_type = _data["token_type"];
            this.username = _data["username"];
            this.clientId = _data["clientId"];
            this.refresh_token = _data["refresh_token"];
            this.refreshTokenExpiresIn = _data["refreshTokenExpiresIn"];
            this.expires_in = _data["expires_in"];
            this.expires = _data["expires"];
        }
    }

    static fromJS(data: any): UserTokenDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserTokenDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["access_token"] = this.access_token;
        data["token_type"] = this.token_type;
        data["username"] = this.username;
        data["clientId"] = this.clientId;
        data["refresh_token"] = this.refresh_token;
        data["refreshTokenExpiresIn"] = this.refreshTokenExpiresIn;
        data["expires_in"] = this.expires_in;
        data["expires"] = this.expires;
        return data;
    }
}

export interface IUserTokenDTO {
    access_token?: string | undefined;
    token_type?: string | undefined;
    username?: string | undefined;
    clientId?: string | undefined;
    refresh_token?: string | undefined;
    refreshTokenExpiresIn?: number;
    expires_in?: number;
    expires?: string | undefined;
}

export class UserLoginDTO implements IUserLoginDTO {
    userName?: string | undefined;
    password?: string | undefined;
    grant_Type?: string | undefined;
    client_Id?: string | undefined;
    client_Secret?: string | undefined;
    refresh_Token?: string | undefined;

    constructor(data?: IUserLoginDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.grant_Type = _data["grant_Type"];
            this.client_Id = _data["client_Id"];
            this.client_Secret = _data["client_Secret"];
            this.refresh_Token = _data["refresh_Token"];
        }
    }

    static fromJS(data: any): UserLoginDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["grant_Type"] = this.grant_Type;
        data["client_Id"] = this.client_Id;
        data["client_Secret"] = this.client_Secret;
        data["refresh_Token"] = this.refresh_Token;
        return data;
    }
}

export interface IUserLoginDTO {
    userName?: string | undefined;
    password?: string | undefined;
    grant_Type?: string | undefined;
    client_Id?: string | undefined;
    client_Secret?: string | undefined;
    refresh_Token?: string | undefined;
}

export class ClientDTO implements IClientDTO {
    id?: number;
    address?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    zip?: string | undefined;
    isActive?: boolean;

    constructor(data?: IClientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.zip = _data["zip"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ClientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["address"] = this.address;
        data["city"] = this.city;
        data["email"] = this.email;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["zip"] = this.zip;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IClientDTO {
    id?: number;
    address?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    zip?: string | undefined;
    isActive?: boolean;
}

export class PagedResultDTOOfClientDTO implements IPagedResultDTOOfClientDTO {
    items?: ClientDTO[] | undefined;
    totalNumberOfItems?: number;

    constructor(data?: IPagedResultDTOOfClientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ClientDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfClientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfClientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfClientDTO {
    items?: ClientDTO[] | undefined;
    totalNumberOfItems?: number;
}

export class FilterDTO implements IFilterDTO {
    isComplex?: boolean;
    condition?: FilterCondition | undefined;
    field?: string | undefined;
    operator?: FilterOperator | undefined;
    value?: string | undefined;
    predicates?: FilterDTO[] | undefined;

    constructor(data?: IFilterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isComplex = _data["isComplex"];
            this.condition = _data["condition"];
            this.field = _data["field"];
            this.operator = _data["operator"];
            this.value = _data["value"];
            if (Array.isArray(_data["predicates"])) {
                this.predicates = [] as any;
                for (let item of _data["predicates"])
                    this.predicates!.push(FilterDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FilterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isComplex"] = this.isComplex;
        data["condition"] = this.condition;
        data["field"] = this.field;
        data["operator"] = this.operator;
        data["value"] = this.value;
        if (Array.isArray(this.predicates)) {
            data["predicates"] = [];
            for (let item of this.predicates)
                data["predicates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterDTO {
    isComplex?: boolean;
    condition?: FilterCondition | undefined;
    field?: string | undefined;
    operator?: FilterOperator | undefined;
    value?: string | undefined;
    predicates?: FilterDTO[] | undefined;
}

export enum FilterCondition {
    And = 0,
    Or = 1,
}

export enum FilterOperator {
    StartsWith = 0,
    EndsWith = 1,
    Contains = 2,
    Equal = 3,
    NotEqual = 4,
    GreaterThan = 5,
    GreaterThanOrEqual = 6,
    LessThan = 7,
    LessThanOrEqual = 8,
    IsNull = 9,
    IsNotNull = 10,
    Any = 11,
    None = 12,
    Empty = 13,
    NotEmpty = 14,
    DoesNotStartWith = 15,
    DoesNotEndWith = 16,
    DoesNotContain = 17,
}

export enum SortDirection {
    Ascending = 0,
    Descending = 1,
}

export class PagedResultDTOOfIncidentDTO implements IPagedResultDTOOfIncidentDTO {
    items?: IncidentDTO[] | undefined;
    totalNumberOfItems?: number;

    constructor(data?: IPagedResultDTOOfIncidentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(IncidentDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfIncidentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfIncidentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfIncidentDTO {
    items?: IncidentDTO[] | undefined;
    totalNumberOfItems?: number;
}

export class IncidentDTO implements IIncidentDTO {
    id?: number;
    statusServiceId?: number;
    statusServiceName?: string | undefined;
    status?: ServiceStatusLevel;
    description?: string;
    sendNotification?: boolean;
    isDeleted?: boolean;
    createdOn?: DateTime;
    messages?: IncidentMessageDTO[] | undefined;

    constructor(data?: IIncidentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusServiceId = _data["statusServiceId"];
            this.statusServiceName = _data["statusServiceName"];
            this.status = _data["status"];
            this.description = _data["description"];
            this.sendNotification = _data["sendNotification"];
            this.isDeleted = _data["isDeleted"];
            this.createdOn = _data["createdOn"] ? DateTime.fromISO(_data["createdOn"].toString()) : undefined as any;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(IncidentMessageDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IncidentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusServiceId"] = this.statusServiceId;
        data["statusServiceName"] = this.statusServiceName;
        data["status"] = this.status;
        data["description"] = this.description;
        data["sendNotification"] = this.sendNotification;
        data["isDeleted"] = this.isDeleted;
        data["createdOn"] = this.createdOn ? this.createdOn.toString() : undefined as any;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IIncidentDTO {
    id?: number;
    statusServiceId?: number;
    statusServiceName?: string | undefined;
    status?: ServiceStatusLevel;
    description?: string;
    sendNotification?: boolean;
    isDeleted?: boolean;
    createdOn?: DateTime;
    messages?: IncidentMessageDTO[] | undefined;
}

export enum ServiceStatusLevel {
    Operational = 0,
    Degraded = 1,
    Down = 2,
}

export class IncidentMessageDTO implements IIncidentMessageDTO {
    id?: number;
    language?: string;
    message?: string;

    constructor(data?: IIncidentMessageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.language = _data["language"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): IncidentMessageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentMessageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["language"] = this.language;
        data["message"] = this.message;
        return data;
    }
}

export interface IIncidentMessageDTO {
    id?: number;
    language?: string;
    message?: string;
}

export class CreateIncidentDTO implements ICreateIncidentDTO {
    statusServiceId!: number;
    status!: ServiceStatusLevel;
    description!: string;
    sendNotification?: boolean;
    clientIds?: number[] | undefined;
    messages?: CreateIncidentMessageDTO[] | undefined;

    constructor(data?: ICreateIncidentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusServiceId = _data["statusServiceId"];
            this.status = _data["status"];
            this.description = _data["description"];
            this.sendNotification = _data["sendNotification"];
            if (Array.isArray(_data["clientIds"])) {
                this.clientIds = [] as any;
                for (let item of _data["clientIds"])
                    this.clientIds!.push(item);
            }
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(CreateIncidentMessageDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateIncidentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIncidentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusServiceId"] = this.statusServiceId;
        data["status"] = this.status;
        data["description"] = this.description;
        data["sendNotification"] = this.sendNotification;
        if (Array.isArray(this.clientIds)) {
            data["clientIds"] = [];
            for (let item of this.clientIds)
                data["clientIds"].push(item);
        }
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateIncidentDTO {
    statusServiceId: number;
    status: ServiceStatusLevel;
    description: string;
    sendNotification?: boolean;
    clientIds?: number[] | undefined;
    messages?: CreateIncidentMessageDTO[] | undefined;
}

export class CreateIncidentMessageDTO implements ICreateIncidentMessageDTO {
    language!: string;
    message!: string;

    constructor(data?: ICreateIncidentMessageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CreateIncidentMessageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIncidentMessageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["message"] = this.message;
        return data;
    }
}

export interface ICreateIncidentMessageDTO {
    language: string;
    message: string;
}

export class PagedResultDTOOfInfoPopupDTO implements IPagedResultDTOOfInfoPopupDTO {
    items?: InfoPopupDTO[] | undefined;
    totalNumberOfItems?: number;

    constructor(data?: IPagedResultDTOOfInfoPopupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InfoPopupDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfInfoPopupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfInfoPopupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfInfoPopupDTO {
    items?: InfoPopupDTO[] | undefined;
    totalNumberOfItems?: number;
}

export class InfoPopupDTO implements IInfoPopupDTO {
    id?: number;
    startDate?: DateTime;
    endDate?: DateTime;
    platform?: InfoPopupPlatform;
    versionComparison?: VersionComparisonType;
    version?: string | undefined;
    isDeleted?: boolean;
    translations?: InfoPopupTranslationDTO[] | undefined;

    constructor(data?: IInfoPopupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : undefined as any;
            this.platform = _data["platform"];
            this.versionComparison = _data["versionComparison"];
            this.version = _data["version"];
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(InfoPopupTranslationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InfoPopupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InfoPopupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDate"] = this.startDate ? this.startDate.toString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toString() : undefined as any;
        data["platform"] = this.platform;
        data["versionComparison"] = this.versionComparison;
        data["version"] = this.version;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInfoPopupDTO {
    id?: number;
    startDate?: DateTime;
    endDate?: DateTime;
    platform?: InfoPopupPlatform;
    versionComparison?: VersionComparisonType;
    version?: string | undefined;
    isDeleted?: boolean;
    translations?: InfoPopupTranslationDTO[] | undefined;
}

export enum InfoPopupPlatform {
    None = 0,
    Android = 1,
    IOS = 2,
}

export enum VersionComparisonType {
    Exact = 0,
    GreaterThan = 1,
    LessThan = 2,
}

export class InfoPopupTranslationDTO implements IInfoPopupTranslationDTO {
    id?: number;
    language?: string;
    title?: string;
    body?: string;

    constructor(data?: IInfoPopupTranslationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.language = _data["language"];
            this.title = _data["title"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): InfoPopupTranslationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InfoPopupTranslationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["language"] = this.language;
        data["title"] = this.title;
        data["body"] = this.body;
        return data;
    }
}

export interface IInfoPopupTranslationDTO {
    id?: number;
    language?: string;
    title?: string;
    body?: string;
}

export class CreateInfoPopupDTO implements ICreateInfoPopupDTO {
    startDate!: DateTime;
    endDate!: DateTime;
    platform!: InfoPopupPlatform;
    versionComparison!: VersionComparisonType;
    version?: string | undefined;
    translations!: CreateInfoPopupTranslationDTO[];

    constructor(data?: ICreateInfoPopupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.translations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : undefined as any;
            this.platform = _data["platform"];
            this.versionComparison = _data["versionComparison"];
            this.version = _data["version"];
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(CreateInfoPopupTranslationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateInfoPopupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInfoPopupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toString() : undefined as any;
        data["platform"] = this.platform;
        data["versionComparison"] = this.versionComparison;
        data["version"] = this.version;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateInfoPopupDTO {
    startDate: DateTime;
    endDate: DateTime;
    platform: InfoPopupPlatform;
    versionComparison: VersionComparisonType;
    version?: string | undefined;
    translations: CreateInfoPopupTranslationDTO[];
}

export class CreateInfoPopupTranslationDTO implements ICreateInfoPopupTranslationDTO {
    language!: string;
    title!: string;
    body!: string;

    constructor(data?: ICreateInfoPopupTranslationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.title = _data["title"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): CreateInfoPopupTranslationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInfoPopupTranslationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["title"] = this.title;
        data["body"] = this.body;
        return data;
    }
}

export interface ICreateInfoPopupTranslationDTO {
    language: string;
    title: string;
    body: string;
}

export class UpdateInfoPopupDTO implements IUpdateInfoPopupDTO {
    id!: number;
    startDate?: DateTime | undefined;
    endDate?: DateTime | undefined;
    platform?: InfoPopupPlatform | undefined;
    versionComparison?: VersionComparisonType | undefined;
    version?: string | undefined;
    translations?: UpdateInfoPopupTranslationDTO[] | undefined;

    constructor(data?: IUpdateInfoPopupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : undefined as any;
            this.platform = _data["platform"];
            this.versionComparison = _data["versionComparison"];
            this.version = _data["version"];
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(UpdateInfoPopupTranslationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateInfoPopupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInfoPopupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDate"] = this.startDate ? this.startDate.toString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toString() : undefined as any;
        data["platform"] = this.platform;
        data["versionComparison"] = this.versionComparison;
        data["version"] = this.version;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateInfoPopupDTO {
    id: number;
    startDate?: DateTime | undefined;
    endDate?: DateTime | undefined;
    platform?: InfoPopupPlatform | undefined;
    versionComparison?: VersionComparisonType | undefined;
    version?: string | undefined;
    translations?: UpdateInfoPopupTranslationDTO[] | undefined;
}

export class UpdateInfoPopupTranslationDTO implements IUpdateInfoPopupTranslationDTO {
    language!: string;
    title!: string;
    body!: string;

    constructor(data?: IUpdateInfoPopupTranslationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.title = _data["title"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): UpdateInfoPopupTranslationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInfoPopupTranslationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["title"] = this.title;
        data["body"] = this.body;
        return data;
    }
}

export interface IUpdateInfoPopupTranslationDTO {
    language: string;
    title: string;
    body: string;
}

export class SendPushNotificationDTO implements ISendPushNotificationDTO {
    token?: string;
    pushNotification?: PushNotificationDTO;
    isDataMessage?: boolean;
    channelId?: string | undefined;
    sound?: string | undefined;

    constructor(data?: ISendPushNotificationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.pushNotification = _data["pushNotification"] ? PushNotificationDTO.fromJS(_data["pushNotification"]) : undefined as any;
            this.isDataMessage = _data["isDataMessage"];
            this.channelId = _data["channelId"];
            this.sound = _data["sound"];
        }
    }

    static fromJS(data: any): SendPushNotificationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SendPushNotificationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["pushNotification"] = this.pushNotification ? this.pushNotification.toJSON() : undefined as any;
        data["isDataMessage"] = this.isDataMessage;
        data["channelId"] = this.channelId;
        data["sound"] = this.sound;
        return data;
    }
}

export interface ISendPushNotificationDTO {
    token?: string;
    pushNotification?: PushNotificationDTO;
    isDataMessage?: boolean;
    channelId?: string | undefined;
    sound?: string | undefined;
}

export class PushNotificationDTO implements IPushNotificationDTO {
    title?: string;
    body?: string;
    type?: MessageType;
    parameters?: string[] | undefined;

    constructor(data?: IPushNotificationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.body = _data["body"];
            this.type = _data["type"];
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(item);
            }
        }
    }

    static fromJS(data: any): PushNotificationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PushNotificationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["body"] = this.body;
        data["type"] = this.type;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item);
        }
        return data;
    }
}

export interface IPushNotificationDTO {
    title?: string;
    body?: string;
    type?: MessageType;
    parameters?: string[] | undefined;
}

export enum MessageType {
    Undefined = 0,
    Message = 1,
    Warning = 2,
    Reaction = 3,
    Alarm = 4,
}

export class PagedResultDTOOfServiceClientDTO implements IPagedResultDTOOfServiceClientDTO {
    items?: ServiceClientDTO[] | undefined;
    totalNumberOfItems?: number;

    constructor(data?: IPagedResultDTOOfServiceClientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceClientDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfServiceClientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfServiceClientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfServiceClientDTO {
    items?: ServiceClientDTO[] | undefined;
    totalNumberOfItems?: number;
}

export class ServiceClientDTO implements IServiceClientDTO {
    id?: number;
    name?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;

    constructor(data?: IServiceClientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ServiceClientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceClientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        data["city"] = this.city;
        data["email"] = this.email;
        return data;
    }
}

export interface IServiceClientDTO {
    id?: number;
    name?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
}

export class StatusServiceDTO implements IStatusServiceDTO {
    id?: number;
    name?: string;
    description?: string | undefined;
    baseStatus?: ServiceStatusLevel;
    effectiveStatus?: ServiceStatusLevel;
    reasons?: string[];

    constructor(data?: IStatusServiceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.baseStatus = _data["baseStatus"];
            this.effectiveStatus = _data["effectiveStatus"];
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(item);
            }
        }
    }

    static fromJS(data: any): StatusServiceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StatusServiceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["baseStatus"] = this.baseStatus;
        data["effectiveStatus"] = this.effectiveStatus;
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item);
        }
        return data;
    }
}

export interface IStatusServiceDTO {
    id?: number;
    name?: string;
    description?: string | undefined;
    baseStatus?: ServiceStatusLevel;
    effectiveStatus?: ServiceStatusLevel;
    reasons?: string[];
}

export class CreateStatusServiceDTO implements ICreateStatusServiceDTO {
    name!: string;
    description?: string | undefined;
    baseStatus?: ServiceStatusLevel;

    constructor(data?: ICreateStatusServiceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.baseStatus = _data["baseStatus"];
        }
    }

    static fromJS(data: any): CreateStatusServiceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStatusServiceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["baseStatus"] = this.baseStatus;
        return data;
    }
}

export interface ICreateStatusServiceDTO {
    name: string;
    description?: string | undefined;
    baseStatus?: ServiceStatusLevel;
}

export class UpdateStatusServiceDTO implements IUpdateStatusServiceDTO {
    id!: number;
    name?: string | undefined;
    description?: string | undefined;
    baseStatus?: ServiceStatusLevel | undefined;

    constructor(data?: IUpdateStatusServiceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.baseStatus = _data["baseStatus"];
        }
    }

    static fromJS(data: any): UpdateStatusServiceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStatusServiceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["baseStatus"] = this.baseStatus;
        return data;
    }
}

export interface IUpdateStatusServiceDTO {
    id: number;
    name?: string | undefined;
    description?: string | undefined;
    baseStatus?: ServiceStatusLevel | undefined;
}

export class UserInfoDTO implements IUserInfoDTO {
    userId?: string | undefined;
    clientId?: number | undefined;
    client?: ClientDTO | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    language?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: Role[] | undefined;
    enabled?: boolean;
    accessCode?: string | undefined;
    accessCodeValidUntil?: DateTime | undefined;
    accessCodeGeneratedOn?: DateTime | undefined;
    accessCodeUsedOn?: DateTime | undefined;
    permanentAccessCode?: boolean;

    constructor(data?: IUserInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.clientId = _data["clientId"];
            this.client = _data["client"] ? ClientDTO.fromJS(_data["client"]) : undefined as any;
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.language = _data["language"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.enabled = _data["enabled"];
            this.accessCode = _data["accessCode"];
            this.accessCodeValidUntil = _data["accessCodeValidUntil"] ? DateTime.fromISO(_data["accessCodeValidUntil"].toString()) : undefined as any;
            this.accessCodeGeneratedOn = _data["accessCodeGeneratedOn"] ? DateTime.fromISO(_data["accessCodeGeneratedOn"].toString()) : undefined as any;
            this.accessCodeUsedOn = _data["accessCodeUsedOn"] ? DateTime.fromISO(_data["accessCodeUsedOn"].toString()) : undefined as any;
            this.permanentAccessCode = _data["permanentAccessCode"];
        }
    }

    static fromJS(data: any): UserInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["clientId"] = this.clientId;
        data["client"] = this.client ? this.client.toJSON() : undefined as any;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["language"] = this.language;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["enabled"] = this.enabled;
        data["accessCode"] = this.accessCode;
        data["accessCodeValidUntil"] = this.accessCodeValidUntil ? this.accessCodeValidUntil.toString() : undefined as any;
        data["accessCodeGeneratedOn"] = this.accessCodeGeneratedOn ? this.accessCodeGeneratedOn.toString() : undefined as any;
        data["accessCodeUsedOn"] = this.accessCodeUsedOn ? this.accessCodeUsedOn.toString() : undefined as any;
        data["permanentAccessCode"] = this.permanentAccessCode;
        return data;
    }
}

export interface IUserInfoDTO {
    userId?: string | undefined;
    clientId?: number | undefined;
    client?: ClientDTO | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    language?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: Role[] | undefined;
    enabled?: boolean;
    accessCode?: string | undefined;
    accessCodeValidUntil?: DateTime | undefined;
    accessCodeGeneratedOn?: DateTime | undefined;
    accessCodeUsedOn?: DateTime | undefined;
    permanentAccessCode?: boolean;
}

export enum Role {
    None = 0,
    Admin = 1,
    ClientAdmin = 2,
    WebUser = 3,
    MobileUser = 4,
    RestService = 5,
}

export class PagedResultDTOOfUserInfoDTO implements IPagedResultDTOOfUserInfoDTO {
    items?: UserInfoDTO[] | undefined;
    totalNumberOfItems?: number;

    constructor(data?: IPagedResultDTOOfUserInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserInfoDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfUserInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfUserInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfUserInfoDTO {
    items?: UserInfoDTO[] | undefined;
    totalNumberOfItems?: number;
}

export class UpdateUserInfoDTO implements IUpdateUserInfoDTO {
    userId!: string;
    clientId?: number | undefined;
    email?: string | undefined;
    enabled?: boolean | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    language?: string | undefined;
    phoneNumber?: string | undefined;
    userName?: string | undefined;
    roles?: Role[] | undefined;
    accessCodeValidUntil?: DateTime | undefined;

    constructor(data?: IUpdateUserInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.clientId = _data["clientId"];
            this.email = _data["email"];
            this.enabled = _data["enabled"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.language = _data["language"];
            this.phoneNumber = _data["phoneNumber"];
            this.userName = _data["userName"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.accessCodeValidUntil = _data["accessCodeValidUntil"] ? DateTime.fromISO(_data["accessCodeValidUntil"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateUserInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["clientId"] = this.clientId;
        data["email"] = this.email;
        data["enabled"] = this.enabled;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["language"] = this.language;
        data["phoneNumber"] = this.phoneNumber;
        data["userName"] = this.userName;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["accessCodeValidUntil"] = this.accessCodeValidUntil ? this.accessCodeValidUntil.toString() : undefined as any;
        return data;
    }
}

export interface IUpdateUserInfoDTO {
    userId: string;
    clientId?: number | undefined;
    email?: string | undefined;
    enabled?: boolean | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    language?: string | undefined;
    phoneNumber?: string | undefined;
    userName?: string | undefined;
    roles?: Role[] | undefined;
    accessCodeValidUntil?: DateTime | undefined;
}

export class CreateMobileUserDTO implements ICreateMobileUserDTO {
    clientId!: number;
    email!: string;
    employeeNumber?: string | undefined;
    firstname!: string;
    lastname!: string;
    language?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: ICreateMobileUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.email = _data["email"];
            this.employeeNumber = _data["employeeNumber"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.language = _data["language"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): CreateMobileUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMobileUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["email"] = this.email;
        data["employeeNumber"] = this.employeeNumber;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["language"] = this.language;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ICreateMobileUserDTO {
    clientId: number;
    email: string;
    employeeNumber?: string | undefined;
    firstname: string;
    lastname: string;
    language?: string | undefined;
    phoneNumber?: string | undefined;
}

export class CreateUserDTO implements ICreateUserDTO {
    clientId?: number | undefined;
    email!: string;
    firstname!: string;
    lastname!: string;
    language?: string | undefined;
    phoneNumber?: string | undefined;
    password?: string | undefined;
    roles?: Role[] | undefined;

    constructor(data?: ICreateUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.email = _data["email"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.language = _data["language"];
            this.phoneNumber = _data["phoneNumber"];
            this.password = _data["password"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["email"] = this.email;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["language"] = this.language;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface ICreateUserDTO {
    clientId?: number | undefined;
    email: string;
    firstname: string;
    lastname: string;
    language?: string | undefined;
    phoneNumber?: string | undefined;
    password?: string | undefined;
    roles?: Role[] | undefined;
}

export class ChangePasswordDTO implements IChangePasswordDTO {
    oldPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordDTO {
    oldPassword: string;
    newPassword: string;
}

export class SetPasswordDTO implements ISetPasswordDTO {
    newPassword!: string;
    verificationToken!: string;
    userId!: string;
    forgotPasswordProcess?: boolean | undefined;

    constructor(data?: ISetPasswordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"];
            this.verificationToken = _data["verificationToken"];
            this.userId = _data["userId"];
            this.forgotPasswordProcess = _data["forgotPasswordProcess"];
        }
    }

    static fromJS(data: any): SetPasswordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetPasswordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword;
        data["verificationToken"] = this.verificationToken;
        data["userId"] = this.userId;
        data["forgotPasswordProcess"] = this.forgotPasswordProcess;
        return data;
    }
}

export interface ISetPasswordDTO {
    newPassword: string;
    verificationToken: string;
    userId: string;
    forgotPasswordProcess?: boolean | undefined;
}

export class ForgotPasswordDTO implements IForgotPasswordDTO {
    username!: string;

    constructor(data?: IForgotPasswordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): ForgotPasswordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        return data;
    }
}

export interface IForgotPasswordDTO {
    username: string;
}

export class MinimumClientVersionDTO implements IMinimumClientVersionDTO {
    minimumClientVersion?: string | undefined;

    constructor(data?: IMinimumClientVersionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minimumClientVersion = _data["minimumClientVersion"];
        }
    }

    static fromJS(data: any): MinimumClientVersionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MinimumClientVersionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minimumClientVersion"] = this.minimumClientVersion;
        return data;
    }
}

export interface IMinimumClientVersionDTO {
    minimumClientVersion?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}